import request from '../Functions/ajax/request'

import DashboardsStore from '../../Stores/Dashboards'

export default async function SubFamilyPageLoader ({ params })
{
	return { page: getPage({ params }), params };
}

async function getPage ({ params })
{
	DashboardsStore.update(function (store)
	{
		store[params.article_subfamily] ||= { };

		store[params.article_subfamily].subfamily = params.article_subfamily;

		store[params.article_subfamily].categorie = '';
		store[params.article_subfamily].classe = '';
	});

	try
	{
		var { categories=[] } = await request('/articles/get-filters-options')
		.config({ min_req_time: 0 })
		.post({ subfamily: params.article_subfamily });
	}
	catch (e)
	{
		console.error(e);
	}

	const options = Array.isArray(categories)
	? categories.map(val => ({ value: val }))
	: [];

	return { categories: options };
}